var template = require('./index.html');
/**
 * directives.slider Module
 *
 * Description
 */
var app = angular.module('directives.sliderTemplates');
app.directive('sliderTemplates', ['$window', function ($window) {
    return {
        templateUrl: './app/directives/sliderTemplates/index.html',
        controller: [
            '$scope',
            '$element',
            function ($scope, $element) {
                var sliderTemplates = {
                    serviceWidth: 270,
                    itemCounts: 3,
                    currentService: 0,
                    service: [],
                    prevService: function () {
                        if (sliderTemplates.service[0].left != (sliderTemplates.serviceWidth - 280)) {
                            sliderTemplates.service.forEach(function (item, index) {
                                item.left += sliderTemplates.serviceWidth;
                            });
                        }
                    },
                    nextService: function () {
                        sliderTemplates.service.forEach(function (item, index) {
                            item.left -= sliderTemplates.serviceWidth;
                        });
                    }
                };

                var w = angular.element($window);
                $scope.$watch(function () {
                    return {
                        'height': w[0].innerHeight,
                        'width': w[0].innerWidth
                    };
                }, function (newValue, oldValue) {
                    var widthWrapper = Math.floor(newValue.width * 0.75) > 1400 ? 1400 : Math.floor(newValue.width * 0.75);
                    sliderTemplates.itemCounts = Math.floor(widthWrapper / 320) > 2 ? Math.floor(widthWrapper / 320) : 2;
                    sliderTemplates.serviceWidth = Math.floor((widthWrapper-40) / sliderTemplates.itemCounts) > 320 ? Math.floor((widthWrapper-40) / sliderTemplates.itemCounts) : 320;
                    sliderTemplates.service = [
                        {
                            left: sliderTemplates.serviceWidth - 280
                        },
                        {
                            left: sliderTemplates.serviceWidth + 40
                        },
                        {
                            left: 2 * (sliderTemplates.serviceWidth) + 40
                        },
                        {
                            left: 3 * (sliderTemplates.serviceWidth) + 40
                        },
                        {
                            left: 4 * (sliderTemplates.serviceWidth) + 40
                        }];

                }, true);

                w.bind('resize', function () {
                    $scope.$apply();
                });

                $scope.sliderTemplates = sliderTemplates;
            }]
    };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/sliderTemplates/directive.js
 ** module id = 231
 ** module chunks = 1
 **/